import React from "react";
import DocumentInfo from "./DocumentInfo";
import SignatureBoxesPanel, { PeoplePickerUser } from "./SignatureBoxesPanel";
import DriveFile from "../../../../../interfaces/file/DriveFile";
import { SignatureField, SignatureStatus } from "../../../../../interfaces/file/fileSignature/SignatureBox";

interface PDFEditorSidebarProps {
  activeNav: string | null;
  toggleNav: (nav: string) => void;
  fileMetadata: DriveFile | null;
  groupedSignatureFields: { [key: number]: SignatureField[] };
  signatureFields: SignatureField[];
  selectedBoxId: string | null;
  toggleSelectedBox: (boxId: string) => void;
  selectedBox: SignatureField | undefined;
  updateSelectedBox: (updates: Partial<SignatureField>) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showDropdown: boolean;
  setShowDropdown: (v: boolean) => void;
  suggestions: PeoplePickerUser[];
  handleSelect: (email: string) => void;
  signedStatus?: SignatureStatus;
  taskId?: number | null;
  taskTitle?: string | null;
  isLoading: boolean;
}

const PDFEditorSidebar: React.FC<PDFEditorSidebarProps> = (props) => {
  return (
    <div className="sign_right">
      <div className="common_card h-100">
        <DocumentInfo
          fileMetadata={props.fileMetadata}
          activeNav={props.activeNav}
          toggleNav={props.toggleNav}
          status={props.signedStatus}
          taskId={props.taskId}
          taskTitle={props.taskTitle}
        />
        <SignatureBoxesPanel
          activeNav={props.activeNav}
          toggleNav={props.toggleNav}
          groupedSignatureFields={props.groupedSignatureFields}
          signatureFields={props.signatureFields}
          selectedBoxId={props.selectedBoxId}
          toggleSelectedBox={props.toggleSelectedBox}
          selectedBox={props.selectedBox}
          updateSelectedBox={props.updateSelectedBox}
          handleInputChange={props.handleInputChange}
          showDropdown={props.showDropdown}
          setShowDropdown={props.setShowDropdown}
          suggestions={props.suggestions}
          handleSelect={props.handleSelect}
          isLoading={props.isLoading}
        />
      </div>
    </div>
  );
};

export default PDFEditorSidebar;
